import EventEmitter from 'events';
import { CreateClientAsync, ReleaseClient } from '@realeyes/postmessage-api-shim';
import ProxyCollectionSdk from './Proxies/ProxyCollectionSdk';
import Environment from './Environment';

export default class ProxyRecorder extends EventEmitter {
    /**
     * ProxyRecorder constructor
     * @param {ProxyCollectionSdk} sdk
     * @param {Environment} environment
     */
    constructor(sdk, environment) {
        super();

        this.sdk = sdk;
        this.environment = environment;

        this.orientationChangeHandler = this.handleOrientationChange.bind(this);

        this._initialized = false;
    }

    isInitialized() {
        return this._initialized;
    }

    /**
     * Init proxy recorder
     * @param {Environment} environment
     * @param {any} config
     */
    async init(environment, config) {
        const eventsToReplicate = ['error', 'test', 'startTest', 'stopTest', 'startRecording', 'stopRecording'];
        this.config = config;
        this.isRecordingStopped = false;

        const needProxy = config.needProxy && (!environment.isEdge || environment.browserMajorVersion > 80);

        if (needProxy) {
            // token should match with the one specified in Integration.Recoder upon CreateServer
            this.recorder = await CreateClientAsync(window, window.parent, 60 * 60 * 1000 /*60 mins*/, 'RecorderToken');

            eventsToReplicate.forEach((name) => {
                this.recorder.on(name, (data) => {
                    this.emit(name, data);
                });
            });

            window.addEventListener('beforeunload', () => {
                ReleaseClient(this.recorder);
            });

            window.addEventListener('unload', () => {
                ReleaseClient(this.recorder);
            });

            const success = await this.recorder.init(this.sdk.config);
            if (success) {
                this._initialized = true;
            } else {
                throw new Error('integration recorder was not initialized!');
            }
        } else {
            this.recorder = this.sdk.getRecorder();

            eventsToReplicate.forEach((name) => {
                this.recorder.on(name, (data) => {
                    this.emit(name, data);
                });
            });

            this._initialized = true;
        }

        return this;
    }

    async getCurrentDevices() {
        return await this.recorder.getCurrentDevices();
    }

    async getAvailableDevices() {
        return await this.recorder.getAvailableDevices();
    }

    async switchToNextDevice(type) {
        return await this.recorder.switchToNextDevice(type);
    }

    async askPermissions() {
        return await this.recorder.askPermissions();
    }
    getCurrentImage() {
        return this.workImg;
    }

    async showMirrowView() {
        if (this.config.recorderOptions.mirrorViewConfig) {
            let styles = JSON.parse(this.config.recorderOptions.mirrorViewConfig);
            let mobileStlyes = styles.mobile;
            var mirrorViewHolder = document.createElement('div');
            var cameraCircle = document.createElement('div');
            var mirrorVideo = document.createElement('video');

            Object.assign(mirrorViewHolder.style, mobileStlyes.mirrorViewHolder);
            Object.assign(cameraCircle.style, mobileStlyes.cameraCircle);
            Object.assign(mirrorVideo.style, mobileStlyes.mirrorVideo);

            mirrorVideo.setAttribute('playsinline', '');
            mirrorVideo.setAttribute('autoplay', '');
            mirrorVideo.setAttribute('muted', '');

            var constraints = {
                audio: false,
                video: true
            };

            mirrorViewHolder.appendChild(mirrorVideo);
            mirrorViewHolder.appendChild(cameraCircle);

            document.getElementById('resurveycontent').appendChild(mirrorViewHolder);

            navigator.mediaDevices.getUserMedia(constraints).then(function success(stream) {
                mirrorVideo.srcObject = stream;
            });
        }
    }

    handleOrientationChange() {
        console.log('Orientation changed');
        this.isInPortraitMode = Math.abs(window.orientation) !== 90;

        //defaults for portrait mode
        const canvasDefaultWidth = 480;
        const canvasDefaultHeight = 640;
        if (this.isInPortraitMode && screen.width < 480) {
            this.ratio = screen.width / 480;
            canvasDefaultWidth = 480 * this.ratio;
            canvasDefaultHeight = 640 * this.ratio;
        } else if (!this.isInPortraitMode) {
            console.log('ratio ' + this.ratio);
            canvasDefaultWidth = 640 * this.ratio;
            canvasDefaultHeight = 480 * this.ratio;
        }

        this.workCanv.width = Math.round(canvasDefaultWidth);
        this.workCanv.height = Math.round(canvasDefaultHeight);

        if (this.environment.isSafari) {
            if (this.environment.isTabletSize) {
                this.workCanv.style.width = '95%';
            } else {
                this.workCanv.style.width = this.isInPortraitMode ? '95%' : '75%';
            }
        }
    }

    async startStreamValidation(containerId, options) {
        let element = await this.recorder.startStreamValidation(undefined, options);
        this.isInPortraitMode = window.matchMedia('(orientation: portrait)').matches;
        this.ratio = 1;
       
        if (element.tagName && element.tagName.toLowerCase() === 'video') {
            //This case is for standalone
            this.element = element;
            // fix for safari video playing
            this.element.style.width = '1px';
            this.element.style.height = '1px';

            const w = this.element.videoWidth && this.element.videoWidth > this.element.videoHeight ? 640 : 480;
            const h = this.element.videoHeight && this.element.videoWidth < this.element.videoHeight ? 640 : 480;

            document.body.appendChild(this.element);

            this.workCanv = document.createElement('canvas');
            this.workCanv.id = 'v-id';
            this.workCanv.width =
                this.element.videoWidth && this.element.videoWidth > this.element.videoHeight ? 640 : 480;
            this.workCanv.height =
                this.element.videoHeight && this.element.videoWidth < this.element.videoHeight ? 640 : 480;
            this.workCanv.style.width = '100%';
            this.workCtx = this.workCanv.getContext('2d');

            if (this.environment.isSafari && this.environment.isMobile) {
                this.workCanv.style.height = '95%';
            }

            this.workImg = new Image();
            const draw = () => {
                if (!this.element || !this.workCtx) return false;

                let w = this.element.videoWidth && this.element.videoWidth > this.element.videoHeight ? 640 : 480;
                let h = this.element.videoHeight && this.element.videoWidth < this.element.videoHeight ? 640 : 480;
                this.workCanv.width =
                    this.element.videoWidth && this.element.videoWidth > this.element.videoHeight ? 640 : 480;
                this.workCanv.height =
                    this.element.videoHeight && this.element.videoWidth < this.element.videoHeight ? 640 : 480;

                this.workCtx.drawImage(this.element, 0, 0, w, h);
                this.workCtx.save();
                this.workCtx.scale(-1, 1);
                this.workCtx.drawImage(this.element, 0, 0, w * -1, h);
                this.workImg.src = this.workCtx.canvas.toDataURL();
                this.workCtx.restore();

                this.drawTimeout = setTimeout(draw, 20);
            };
            draw();
        } else {
            //This case for integration
            if (element) {
                // todo most probably element is base64 img from integration api
                this.workCanv = document.createElement('canvas');
                this.workCanv.id = 'v-id';

                let canvasDefaultWidth = this.isInPortraitMode ? 480 : 640;
                let canvasDefaultHeight = this.isInPortraitMode ? 640 : 480;

                //This hack needs because of mobile virtual pixel number vs phisycal pixel numbers, iframe, safari and canvas size
                if (this.isInPortraitMode && screen.width < 480) {
                    this.ratio = screen.width / 480;
                    canvasDefaultWidth = 480 * this.ratio;
                    canvasDefaultHeight = 640 * this.ratio;
                } else if (!this.isInPortraitMode && document.documentElement.clientHeight < 480) {
                    this.ratio = document.documentElement.clientHeight / 480;
                    canvasDefaultWidth = 640 * this.ratio;
                    canvasDefaultHeight = 480 * this.ratio;
                }

                this.workCanv.width = Math.round(canvasDefaultWidth);
                this.workCanv.height = Math.round(canvasDefaultHeight);
                this.workCanv.style.width = '100%';

                if (this.environment.isSafari && this.environment.isMobile) {
                    this.workCanv.style.height = '95%';
                    if (this.environment.isTabletSize) {
                        this.workCanv.style.width = '95%';
                    } else {
                        this.workCanv.style.width = this.isInPortraitMode ? '95%' : '75%';
                    }
                }

                this.workCtx = this.workCanv.getContext('2d');
                this.workImg = new Image();
                this.workImg.onload = () => {
                    if (this.workCtx) {
                        const w = Math.round(this.workImg.width * this.ratio);
                        const h = Math.round(this.workImg.height * this.ratio);
                        this.workCtx.drawImage(this.workImg, 0, 0, w, h);

                        // https://stackoverflow.com/questions/19262141/resize-image-with-javascript-canvas-smoothly

                        //TODO: do we need all of these?
                        this.workCtx.save();
                        this.workCtx.scale(-1, 1);
                        this.workCtx.drawImage(this.workImg, 0, 0, w * -1, h);
                        this.workCtx.restore();
                    }
                };

                this.recorder.on('draw', (data) => {
                    if (data) {
                        this.workImg.width = data.width && data.width > data.height ? 640 : 480;
                        this.workImg.height = data.height && data.width < data.height ? 640 : 480;
                        this.workImg.src = data.img;
                    }
                });
            }
        }
      

        this.container = document.querySelector(`#${containerId}`);
        if (this.container) {
            this.container.appendChild(this.workCanv);
        }

        window.addEventListener('orientationchange', this.orientationChangeHandler, false);

        return this.workCanv;
    }

    async stopStreamValidation() {
        if (this.container) {
            this.container.removeChild(this.workCanv);
        }

        if (this.workCanv) {
            this.workCtx = null;
            this.workCanv = null;
        }

        try {
            this.recorder.off('draw');
        } catch (err) {}

        if (this.drawTimeout) {
            clearTimeout(this.drawTimeout);
            this.drawTimeout = null;
        }

        await this.recorder.stopStreamValidation();

        if (this.element) {
            document.body.removeChild(this.element);
        }

        window.removeEventListener('orientationchange', this.orientationChangeHandler, false);
    }

    async start() {
        if (this.recorder) {
            this.recordingId = await this.recorder.startRecording();
            this.connectedTime = new Date();

            return this.recordingId;
        }

        throw new Error('recorder was not initialized');
    }

    async stop() {
        if (this.recordingId && !this.isRecordingStopped) {
            this.isRecordingStopped = true;
            if (this.recorder) {
                return await this.recorder.stopRecording();
            } else {
                throw new Error('recorder was not initialized');
            }
        } else {
            return;
        }
    }
}
